// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'user-close';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M9.714 15.724a4.25 4.25 0 1 0 6.01-6.01 4.25 4.25 0 0 0-6.01 6.01zm1.502-4.508 3.005 3.005m-3.005 0 3.005-3.005m-13.19 1.503A4.784 4.784 0 0 1 7.69 8.32m-4.8-4.367a2.922 2.922 0 1 0 5.844 0 2.922 2.922 0 0 0-5.843 0z'
  />
);

export const viewBox = '0 0 18 18';
